import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

const httpOptions = {
    headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Accept',

        'Access-Control-Allow-Credentials': 'true',
        'Content-Type': 'application/json'
    })
};

const httpGetOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
    }),
    withCredentials: true
};

const httpPostOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    }),
    withCredentials: true
};

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RequestOptions, ResponseContentType, Request, RequestMethod, ResponseType } from '@angular/http';
import { MessageService } from './message.service';
import { CpiHeader } from '../model/CPI';
import { JobPlant } from '../model/JobPlant';


@Injectable({
    providedIn: 'root'
})

export class PlantMasterService {
    private apiEndpoint = environment.apiEndpoint;
    private plantUrl = this.apiEndpoint + 'PlantMaster';
    private jobPlantUrl = this.apiEndpoint + 'JobPlant';

    constructor(private http: HttpClient,
        private messageService: MessageService) {
    }
    importPlantMaster(plantMasterList) {
        let data = JSON.stringify(plantMasterList);
        return this.http.post(this.plantUrl + '/InsertOrUpdatePlantMasterList/', JSON.stringify(plantMasterList), httpPostOptions)
    }

    importJobPlant(jobPlantMasterList, jobNo) {
        let data = JSON.stringify(jobPlantMasterList);
        return this.http.post(this.jobPlantUrl + '/InsertJobPlantList/', JSON.stringify(jobPlantMasterList), httpPostOptions)
    }
    getjobPlantList(): Observable<JobPlant[]> {
        console.log('URL: ' + this.jobPlantUrl + '/GetJobPlantListByJobNo/' + 'null');
        //console.log('List: ' + this.http.get<CpiHeader[]>(this.inspectionUrl + '/GetCPIList/' + '2018-07-07', httpOptions));
        return this.http.get<JobPlant[]>(this.jobPlantUrl + '/GetJobPlantListByJobNo/' + 'null', httpGetOptions)
        // .pipe(
        //     tap(families => this.log(`fetched staffs`)),
        //     catchError(this.handleError('getStaffs', []))
        //   );
    }
}